<template>
  <div class="flexbox">
    <div class="ept-validation">
      <div class="fusion-main-menu full-width flexbox">
        <ul class="items-center">
          <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center">
            <span class="menu-text items-center">{{ chooseYourLanguage }}</span>
          </li>
          <li class="weglot-lang menu-item-weglot weglot-language weglot-flags flag-0 weglot-fr fr menu-item menu-item-type-custom menu-item-object-custom menu-item-home menu-item-weglot-13469-fr" data-item-id="weglot-13469-fr" data-classes="weglot-lang">
            <a class="fusion-bar-highlight" @click="chooseLang('fr')" title="Français" data-wg-notranslate="true">
              <span class="menu-text">Français</span>
            </a>
          </li>
          <li class="weglot-lang menu-item-weglot weglot-language weglot-flags flag-0 weglot-en en menu-item menu-item-type-custom menu-item-object-custom menu-item-home menu-item-weglot-13469-en" data-item-id="weglot-13469-en" data-classes="weglot-lang">
            <a class="fusion-bar-highlight" @click="chooseLang('en')" title="English" data-wg-notranslate="true">
              <span class="menu-text">English</span>
            </a>
          </li>
        </ul>
      </div>
      <br />
      <br />
      <h2>
        <span>{{ title }}</span>
      </h2>
      <h4>
        <span>{{ subtitle }}</span>
      </h4>
      <div>
        <ul>
          <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center justify-start">
            {{ anonymousMode }}
          </li>
          <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center justify-start">
            {{ emailMode }}
          </li>
          <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center flexbox">
            <form id="ept-form" class="wpcf7-form" @submit="onSubmit" method="post" enctype="multipart/form-data">
              <p>
                <span class="wpcf7-form-control-wrap file">
                  <input type="file" name="file" />
                </span>
              </p>
              <p>
                <span class="wpcf7-form-control-wrap email">
                  <input type="email" name="email" :placeholder="emailPlaceholder" value="" size="40"
                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" />
                </span>
              </p>
              <input type="submit" :value="doTest" /><br />
            </form>
          </li>
          <li v-if="loader" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center flexbox q-mt-md">
            {{ pleaseWait }}...
            <img class="rotating" src="../assets/img/applications-system.png" />
          </li>
          <li v-if="nofile" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center flexbox q-mt-md">
            <h3>{{ error }} : {{ errorNoFile }}</h3>
          </li>
          <li v-if="quotaError" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center flexbox q-mt-md">
            <h3>{{ error }} : {{ quotaError }}</h3>
            <h5>{{ waitBeforeRetry }}</h5>
          </li>
          <li v-if="unexpectedError" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center flexbox q-mt-md">
            <h3>{{ error }} : {{ errorUnexpected }}</h3>
            <h4>{{ technicalDetails }} :</h4>
            <code><pre>{{ unexpectedError }}</pre></code>
          </li>
          <li v-if="results" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-home items-center flexbox q-mt-md">
            {{ results.message }}
            <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" :class="statusImage" />
            <br />
            <span v-if="results.emailed">{{ reportSent }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EptValidation',
  data () {
    return {
      language: this.defaultLanguage(),
      nofile: null,
      loader: false,
      quotaError: null,
      unexpectedError: null,
      results: null
    }
  },
  computed: {
    statusImage: function () {
      if (this.results) {
        return [ 'upload-status', 'upload-status-' + this.results.status ]
      } else {
        return undefined
      }
    },
    title () {
      return this.language === 'fr' ? 'Validation des EPT' : 'EPT validation'
    },
    chooseYourLanguage () {
      return this.language === 'fr' ? 'choisissez votre langue' : 'choose your language'
    },
    subtitle () {
      return this.language === 'fr' ? 'Sur cette page, vous pouvez tester la validité de vos fichiers EPT :' : 'On this page, you can test and validate your EPT :'
    },
    anonymousMode () {
      return this.language === 'fr' ? 'de manière anonyme (sans préciser votre email), le rapport de validation vous indiquera simplement si le fichier est conforme, contient des avertissements ou bien est invalide' : 'Anonymously (you don’t need to specify your email address), the result will show if the EPT is valid, with warnings or invalid.'
    },
    emailMode () {
      return this.language === 'fr' ? 'en précisant votre email, le rapport complet de validation vous sera alors envoyé à votre adresse électronique' : 'By mentionning your email address, the detailled validation results (line by line) will be sent to you.'
    },
    emailPlaceholder () {
      return this.language === 'fr' ? 'votre email pour recevoir le rapport d\'analyse complet' : 'please specify your email for the detailled results'
    },
    doTest () {
      return this.language === 'fr' ? 'tester le fichier' : 'Test your EPT'
    },
    error () {
      return this.language === 'fr' ? 'Erreur' : 'Error'
    },
    errorNoFile () {
      return this.language === 'fr' ? 'Vous devez choisir un fichier.' : 'You must choose a file.'
    },
    pleaseWait () {
      return this.language === 'fr' ? 'Veuillez patienter' : 'Please wait'
    },
    waitBeforeRetry () {
      return this.language === 'fr' ? 'Veuillez patienter quelques minutes avant de ré-essayer.' : 'Please wait a few minutes before trying again.'
    },
    errorUnexpected () {
      return this.language === 'fr' ? 'une erreur inattendue s\'est produite' : 'an unexpected error occurred'
    },
    technicalDetails () {
      return this.language === 'fr' ? 'Détails techniques' : 'Technical details'
    },
    reportSent () {
      return this.language === 'fr' ? 'Le rapport détaillé a été envoyé à votre adresse électronique.' : 'A complete report has been sent to your email address.'
    }
  },
  methods: {
    defaultLanguage () {
      if (navigator) {
        const l = navigator.language || navigator.userLanguage
        if (l) {
          return l.toLowerCase().indexOf('en') !== -1 ? 'en' : 'fr'
        }
      }
      return 'fr'
    },
    chooseLang (lang) {
      this.language = lang
    },
    reset: function () {
      this.nofile = null
      this.loader = false
      this.quotaError = null
      this.unexpectedError = null
      this.results = null
    },
    isEmailSet: function (email) {
      return email && email.value
    },
    submitUrl: function (email) {
      return '/api/v1/front/ept/validate' + (this.isEmailSet(email) ? '' : '/anonymous')
    },
    onSubmit: function (event) {
      event.preventDefault()
      event.stopPropagation()
      const zeform = document.getElementById('ept-form')
      const zefile = zeform.elements['file']
      if (zefile.value) {
        const url = this.submitUrl(zeform.elements['email'])
        const fd = new FormData(zeform)
        this.reset()
        this.loader = true
        this.axios.post(url, fd).then(response => {
          this.loader = false
          // console.log('success : ', response)
          const res = {
            emailed: this.isEmailSet(zeform.elements['email'])
          }
          switch (response.data) {
            case 'GREEN':
              res.status = 'high'
              res.message = 'fichier valide'
              break
            case 'ORANGE':
              res.status = 'medium'
              res.message = 'fichier avec avertissement(s)'
              break
            case 'RED':
              res.status = 'low'
              res.message = 'fichier invalide'
              break
          }
          this.results = res
        }).catch(error => {
          this.loader = false
          if (error.response) {
            // The request was made and the server responded with a status that falls out of the range of 2xx
            if (error.response.status === 429) {
              this.quotaError = error.response.data
            } else {
              if (typeof error.response.data === 'object') {
                this.unexpectedError = JSON.stringify(error.response.data, undefined, 2)
              } else {
                this.unexpectedError = error.response.data
              }
            }
          } else if (error.request) {
            // The request was made but no response was received
            this.unexpectedError = JSON.stringify(error.request, undefined, 2)
          } else {
            // Something happened in setting up the request that triggered an Error
            this.unexpectedError = error.message
          }
        })
      } else {
        this.nofile = true
      }
    }
  }
}
</script>

<style>

.flexbox {
  display: flex;
  justify-content: center;
}

.full-width {
  width: 100%;
}

.items-center {
  display: flex;
  align-items: center;
}

.justify-start {
  justify-content: start;
  align-items: start;
  text-align: left;
}

.q-mt-md {
  margin-top: 2rem;
}

.ept-validation {
  max-width: 800px;
  font-family: "Lucida Grande","Lucida Sans Unicode",Verdana,sans-serif;
  font-size: 15px;
  font-weight: 300;
  line-height: 1.86;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  background: #fff;
  color: #343434;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

#ept-form {
  width: 80%;
}
.upload-status {
  width: 128px;
  height: 128px;
  margin: 0px;
  padding: 0px;
  border-top-style: none;
  border-bottom-style: none;
  border-right-style: none;
  border-left-style: none;
}
.upload-status-high {
  background-image: url('../assets/img/security-high.png');
}
.upload-status-medium {
  background-image: url('../assets/img/security-medium.png');
}
.upload-status-low {
  background-image: url('../assets/img/security-low.png');
}
@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

</style>



// WEBPACK FOOTER //
// src/components/EptValidation.vue